import { Droplet, Droplets, Feather, Leaf, RefreshCcw, Shield, ShieldCheck, Sparkles, Sun, Users, Waves, Wind, Flower2, FlaskConicalOff, Link2, BadgeCheck } from "lucide-react";
import { HelichrysumIcon } from "@/components/brand/HelichrysumIcon";

const MAP = {
  "Con postbiotici dell'elicriso": HelichrysumIcon,
  Battericida: ShieldCheck,
  Fungicida: Sun,
  "Attivo contro il 2-nonenale": Waves,
  Antinfiammatorio: Flower2,
  Antiallergico: Leaf,
  "Senza conservanti": FlaskConicalOff,
  Nutre: Droplet,
  Lenisce: Feather,
  Rigenera: RefreshCcw,
  Detergono: Droplets,
  Rinfrescano: Wind,
  Proteggono: Shield,
  "Massima assorbenza": Droplets,
  "Pelle asciutta": Leaf,
  "Massimo comfort": Feather,
  "Barriere laterali anti-perdita": Shield,
  "Chiusure regolabili a strappo": Link2,
  "Morbido e confortevole": Feather,
  "Dermatologicamente testato": BadgeCheck,
  "Unisex per adulti": Users,
};

export const claimIcon = (claim) => MAP[claim] ?? Sparkles;
